import { Language } from "@salon/types";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

// Default language
export const DEFAULT_LANGUAGE = Language.EN;

// List of namespaces
const namespaces = [
  "ai-chat",
  "common",
  "dashboard",
  "appointments",
  "customers",
  "discounts",
  "settings",
  "services",
  "errors",
  "forms",
  "validation",
  "auth",
  "pages",
  "calendar",
  "newCalendar",
  "notifications",
  "reports",
  "reviews",
];

// Lazy load translation resources
const loadResources = (language: string, namespace: string) => {
  return import(`./locales/${language}/${namespace}.json`);
};

// Initialize i18next with lazy loading
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(
    resourcesToBackend((language: string, namespace: string) => loadResources(language, namespace))
  )
  .init({
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,

    // Language detection options
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "salon-language",
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // React-specific options
    react: {
      useSuspense: true, // Enable Suspense for async translations
    },

    // Default namespace
    defaultNS: "common",
    ns: namespaces,

    // Lazy loading options
    partialBundledLanguages: true,
    load: "currentOnly", // Only load current language
  });

export default i18n;
